// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VIPf","controls":"styles_controls__1vkSp","charLimit":"styles_charLimit__KtfR_","input":"styles_input__3v-h3","send":"styles_send__2YbDS"};